import { Time } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AbpSessionService } from 'abp-ng2-module';
import { DateTime } from 'luxon';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { interval, Subscription } from 'rxjs';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, CalculationTimeAndAttendanceDto, CheckInCheckOutDto, CombineUserInfoDto, CompanyProfileServiceProxy, GetAllCurrentProjectDto, LocationSettingInfoDto, ProjectMemberImagesDto, ProjectServiceProxy, SetUserStatusDto, TimeAndAttendanceServiceProxy, TimeAndAttendanceUserInfoDto, TrackWorkingDetailCreateOrEditDto, UserServiceProxy, UserStatusEnum } from '../../../../../shared/service-proxies/service-proxies';
import { SignalRService } from '../../../../shared/services/signalr.service';
import { TimeTrackingService } from '../../../time-tracking/Services/time-tracking.service';


@Component({
    selector: 'app-user-infosection',
    templateUrl: './user-infosection.component.html',
    styleUrls: ['./user-infosection.component.css']
})
export class UserInfosectionComponent extends AppComponentBase implements OnInit {
    userDetails =  new TimeAndAttendanceUserInfoDto();
    mySubscription: Subscription;
    userData = new TimeAndAttendanceUserInfoDto();
    @Input() userId: number;
    @Input() tenantId: number; 
@ViewChild('projectsTabs') projectsTabs: TabsetComponent;
status = 1;
progressBar: any = 60;
progressBarForWork;
projectCount;
startDate: any = "May 21,2022";
endDate: any = "Dec 20,2022";
hours: any = 3;
trackWorkingDetail = new TrackWorkingDetailCreateOrEditDto();
locationsData: LocationSettingInfoDto[] = [];
locationSelectedId: number;
workStartTempTime: Date;
workEndTempTime: Date;
locationEmailReceiverDto: ProjectMemberImagesDto[] = [];
selectedLocation: LocationSettingInfoDto;
progressBarForTime;
isLate:boolean = false;
isearly;
isOnTime;
workingType:any;
projectId;
projectType;
activeIndex1: number = 0; 
resolution:string='medium';
getCurrentTime:string;
    activeIndex2: number = 0;
    activeIndex = 0;
     items;
     statusOptions = {  
        1 : "dot-working" ,
        2 : "dot-idle",
        3 : "dot-meeting",
        4 : "dot-checkin",
        5 : "dot-checkout",
        6 : "dot-privatetime",
    };
    currentProjectDto : GetAllCurrentProjectDto[];
    progressBarUserData = new CalculationTimeAndAttendanceDto();
    isProductivityBarTriggered: boolean;
    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy,
        private _sessionService: AbpSessionService,
        private _signalRService: SignalRService,
        private cdRef: ChangeDetectorRef,
        private _router: Router,
        private _companyProfilesServiceProxy: CompanyProfileServiceProxy,
        private _abpSessionService: AbpSessionService, 
        private _projectServiceProxy: ProjectServiceProxy, 
        private _userServiceProxy: UserServiceProxy,
        private _timeandAttendanceServiceProxy: TimeAndAttendanceServiceProxy,
        injector: Injector) { super(injector);}

    userStatusStrArray : string[] = ['Working','Idle','Meeting','Lunch','CheckIn','CheckOut','OnMobile','PrivateTime'];
    userCurrentStatus:string='CheckIn';
    passStatus:number;
    currTime : Date;
    checkInTime: DateTime;
    currentsTime: any;
    finalTime: DateTime;
    isLoaded = false;
    isEmpty = true;
    diffmilisec:number;
    DisplaDiffStr:string;
    isUserCheckedIn: boolean = false; 
    getDate: Date;
    timerSub: Subscription;
    CheckinOffset: any;
    checkInValue: number;

     h:number;
     m:number;
    sec: number;
    currentUserStatus: number;


    time: number = 0;
    interval : any;
    currentTime: number = 0;
    play: boolean = false;
    activeTime: string;
    isProjectDataLoaded: boolean = false;
    


    ngOnInit(): void {
        abp.event.on('passDataToUserInfoSection', (data) => { this.getUserTimeDetailsAfterApi(data, true) })
        this._timeandAttendanceServiceProxy.combineUserDetails(abp?.session?.userId, abp?.session?.tenantId, undefined).subscribe(
            res => {
                this.getUserDetails(res);
                this.workingType = res.workingType;
                this.isEmpty = false;
                this.isLoaded = true;
                this.checkActiveTimeForloggedInUser(res);
                this.userCheckInCheckOut(res);
            }
        )
        // this.getUserDetails(); // merge api with CombineUserDetails
        //this.UserstateChechInCheckOuttimer();
        // this.getUserList();
        //this.checkLocationId()
        this.getCurrentProjectDetails();
        this.play = true;
        this.getDate = new Date();
        // this.userCheckInCheckOut(); // merge api with CombineUserDetails
        // this.checkActiveTimeForloggedInUser(); // merge api with CombineUserDetails
        setTimeout(() => { this.getUserTimedetails(); }, 3000);

        if (!this.tenantId && !this.userId) {
            this.tenantId = abp.session.tenantId;
            this.userId = abp.session.userId;
        }

        this.initSignalR();    
        // this._userServiceProxy.getWorkingTypeStatus(this.tenantId, this.userId).subscribe(r=>{
        //     this.workingType=r;
        //     this.isEmpty = false;
        //     this.isLoaded = true;
        // })
    }


    //Function to check Active Time for logged in User
    checkActiveTimeForloggedInUser(res: CombineUserInfoDto) {
        if (!this.tenantId && !this.userId) {
            this.tenantId = abp.session.tenantId;
            this.userId = abp.session.userId;
        }

        let x = new Date();
        let offset = x.getTimezoneOffset();
        // this._timeandAttendanceServiceProxy.getActiveTimeForPartiuclarUser(this.userId, this.tenantId, DateTime.fromJSDate(this.setZeroTimeForLocalDate(x)), offset, undefined, DateTime.fromJSDate(this.setZeroTimeForLocalDate(x))).subscribe((res) => {
            this.activeTime = res?.activeTimeDetail?.totalActiveTime || '00:00';
           this.activeTime = this.activeTime.slice(0, 5);
        // } )
    }

    // SignalR event for initialize user status
    initSignalR() {
       
        abp.event.on("SignalRAgentUserStatus", (data) => this.createcallBackFunctionsforSignalR(data));
    }

    //** data parmeter used to avoid duplicate event in the applications for signalR
    data: any;
    public async createcallBackFunctionsforSignalR(objValues) {

       // console.log(objValues);
        //** When Page is refreshed at first time signal r event get called multiple times for the same event so timer run by twicely adding value
        if (this.data === undefined) {
            this.data = objValues;
        } else if (this.data.userStatus !== objValues.userStatus) {
            this.data = objValues;
        } else {
            return;
        }
 
        this.timerSub?.unsubscribe();
        await this.userCheckInCheckOut();
    }


    async userCheckInCheckOut(r?: CombineUserInfoDto) {
   
       // this.cdRef.detectChanges();
       if (!r) {
        let d = new Date();
           await this._AllDashboardServiceProxy.getCurrentStateCheckInCheckOut(abp.session.userId, abp.session.tenantId, d.getTimezoneOffset(), DateTime.fromJSDate(this.setZeroTimeForLocalDate(d))).subscribe(r => {
                if (r.userCurrentStatus != UserStatusEnum.Offline) {
                    //this.checkInTime = r.lastCheckInTime;
                    this.CheckinOffset = r.offset;//this.getOffsetFromStartingTime(r.time);
                    this.UserstateChechInCheckOuttimer(this.CheckinOffset);
                    this.passStatus = 6;
                    this.userCurrentStatus = 'CheckOut';
                    this.isUserCheckedIn = false;
                    this.cdRef.detectChanges();
                }
                else {
                    if (r.userCurrentStatus === UserStatusEnum.Offline) {
                        this.userCurrentStatus = 'CheckIn'
                        this.isUserCheckedIn = true;
                        if(r.lastCheckInTime!=undefined){
                            this.currentTime = this.getOffsetForCheckedOut(r.lastCheckInTime, r.time);
                        }
                        this.CheckinOffset = this.currentTime;
                    }
                    this.timerSub?.unsubscribe();
                    this.cdRef.detectChanges();
                }
            });
        } else {
            if (r.userCurrentStatus != UserStatusEnum.Offline) {
                //this.checkInTime = r.lastCheckInTime;
                this.CheckinOffset = r.offset;//this.getOffsetFromStartingTime(r.time);
                this.UserstateChechInCheckOuttimer(this.CheckinOffset);
                this.passStatus = 6;
                this.userCurrentStatus = 'CheckOut';
                this.isUserCheckedIn = false;
                this.cdRef.detectChanges();
            }
            else {
                if (r.userCurrentStatus === UserStatusEnum.Offline) {
                    this.userCurrentStatus = 'CheckIn'
                    this.isUserCheckedIn = true;
                    if(r.lastCheckInTime!=undefined){
                        this.currentTime = this.getOffsetForCheckedOut(r.lastCheckInTime, r.time);
                    }
                    this.CheckinOffset = this.currentTime;
                }
                this.timerSub?.unsubscribe();
                this.cdRef.detectChanges();
            }
        }
        //this.cdRef.detectChanges();
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    UserstateChechInCheckOuttimer(offset?: number) {
    
        
            this.currentTime = offset || 0;
            this.timerSub = interval(1000).subscribe((seconds) => {
                this.currentTime++;
                this.cdRef.detectChanges();
                // keep emitting to update main timer
               // this._timeTrackingService.emitCurrentTask(this);
            });
        
    }
   

    getUserDetails(result: CombineUserInfoDto) {
        // this._AllDashboardServiceProxy.userInfo().subscribe(result => {
        this.userDetails = result.userInfoDetail;
        this.currentUserStatus = result.userCurrentStatus;
            this.isEmpty = false;
            this.isLoaded = true;
            let hours = new Date().getHours();
            let minutes = new Date().getMinutes(); 
            let sec = new Date().getSeconds();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? 0 + minutes : minutes;
            this.getCurrentTime = hours + ':' + minutes + ' '+ ampm;
        
        // });
    }
    getUserStatus(id: UserStatusEnum) {
        //this._projectTaskServiceProxy.status
        return id != null ? UserStatusEnum[id] : "Unknown";
    }
    getCurrentProjectDetails() {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        this._AllDashboardServiceProxy.getAllCurrentProjects().subscribe(result => {          
            this.currentProjectDto = result;
            this.projectCount = this.currentProjectDto.length;
            this.isProjectDataLoaded = true;
        });
    }
    redirectToViewPage(id: number, projectTypeId: number){
        this._router.navigate(['/app/main/projects-new/project-details'], { state: { ProjectId: id, option: projectTypeId } });
    }
    getProjectProgress(startD: Date, endD: Date) {
        if (!startD || !endD) return 0;
        let progressBar=0;
        var startDate = new Date(startD.toString());
        var endDate = new Date(endD.toString());
        const PresentDay = new Date();
                if( (startDate > endDate) || (startDate > PresentDay)){
                    progressBar=0;
                }else if(PresentDay > endDate){
                    progressBar=100;
                }else{
                    progressBar = (PresentDay.getTime() - startDate.getTime())*100/(endDate.getTime() - startDate.getTime());
                }
                progressBar = Math.floor(progressBar);
                return progressBar;
                
        }
        

    getUserTimedetails() {
        if(this.isProductivityBarTriggered) return;
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        this._timeandAttendanceServiceProxy.getUserCalculationBaseOnActivity(abp?.session?.userId, abp?.session?.tenantId, DateTime.fromJSDate(this.setZeroTimeForLocalDate(date)), date.getTimezoneOffset(), DateTime.fromJSDate(this.setZeroTimeForLocalDate(date)), DateTime.fromJSDate(this.setZeroTimeForLocalDate(date)),undefined).subscribe(
        result => {
        // this._AllDashboardServiceProxy.getUserTimeCalculation(0, 0, DateTime.fromJSDate(this.setZeroTimeForLocalDate(date)), date.getTimezoneOffset(), DateTime.fromJSDate(this.setZeroTimeForLocalDate(date))).subscribe(result => {
            this.getUserTimeDetailsAfterApi(result);
        });
    }
    getUserTimeDetailsAfterApi(result, isTriggered = false) {
        this.isProductivityBarTriggered = isTriggered;
        this.progressBarUserData = result;
            abp.event.trigger('getUserTimedetailsOnTimeCards', result);
            //console.log(this.progressBarUserData.minimumUsererWorkingHours + 'MUH');
            this.isLoaded = true;
            this.isEmpty = false;
            let hours = Math.floor(parseInt(this.progressBarUserData.timeAtWork.split(":")[0]));
            let min = parseInt(this.progressBarUserData.timeAtWork.split(":")[1])
            let totalMinutes = hours * 60 + min;
            if (this.progressBarUserData.workStartDate !== undefined)
                this.workStartTempTime = this.progressBarUserData.workStartDate.toJSDate();
            if (this.progressBarUserData.workEndDate !== undefined)
                this.workEndTempTime = this.progressBarUserData.workEndDate.toJSDate();
            var getMinimumHoursDiff = this.progressBarUserData.minimumUsererWorkingHours - totalMinutes;
            //let endTotalMinLeft = Number(this.progressBarUserData.workEndDate.hour * 60 + this.progressBarUserData.workEndDate.minute);
            let finalMinLeft = (getMinimumHoursDiff) / 60;
            let getFinalTime = (Math.round((this.currentTime / 3600)) * 10);
            this.progressBarForTime = getFinalTime;
            //console.log(getFinalTime);
            if (this.progressBarUserData.arrivalTime > this.progressBarUserData.workStartDate) {
                this.isLate = true;
            }
            
            if(this.progressBarUserData.leftDateTime != null){
                let getWorkEndTime = (this.workEndTempTime.getHours() * 60 + this.workEndTempTime.getMinutes());
                let leftTime = (this.progressBarUserData.leftDateTime.hour * 60) + this.progressBarUserData.leftDateTime.minute
                if (Math.round((getWorkEndTime)) > leftTime) {
                    this.isearly = true;
                } else if (Math.round((getWorkEndTime)) < leftTime) {
                    this.isOnTime = true;
                }
            }
    }
    getUserList(){
        this._projectServiceProxy.getProjectMemberImages().subscribe(result => {
            this.locationEmailReceiverDto = result; 
        });
     } 
    getOffsetForCheckedOut(lastCheckIn: DateTime, LastCheckOut:DateTime) {
 
        return Math.floor((new Date(LastCheckOut?.toUTC().toString()).getTime() - new Date(lastCheckIn?.toUTC().toString()).getTime()) / 1000);

    }

    getOffsetFromStartingTime(startingTime: DateTime) {
        // var stHour = startingTime.hour*60*60;
        // var min = startingTime.minute*60;
        // var temp =(new Date(DateTime.now().toUTC().toString());
        // var utchr = temp.getUTCHours()*60*60;
        // var utcmin =  temp.getUTCMinutes()*60;
        // return (utchr+utcmin-st)
       
        
        return Math.floor((new Date(DateTime.now().toUTC().toString()).getTime() - new Date(startingTime?.toUTC().toString()).getTime()) / 1000);
    }

    //** Start Or Stop Timer
    startAndStopTimer() {
       
        this.passStatus = this.userCurrentStatus === 'CheckIn' ? UserStatusEnum.Online : UserStatusEnum.Offline;
        this.userCurrentStatus = this.userCurrentStatus === 'CheckIn' ? 'CheckOut' : 'CheckIn';
        //** If Offline then stop timer
        if (this.passStatus === UserStatusEnum.Offline) {
            this.timerSub.unsubscribe();
                       
        }
        //** If online then start timer from old stoped time
        if (this.passStatus === UserStatusEnum.Online) {
            this.UserstateChechInCheckOuttimer(this.currentTime);            
        }
        //** Send Responce to the backend
        let checkInCheckOutDto = new CheckInCheckOutDto()
        checkInCheckOutDto.userId = 0;
        checkInCheckOutDto.status = this.passStatus;
        this._AllDashboardServiceProxy.checkInCheckOut(checkInCheckOutDto).subscribe(() => {  
            if (this.passStatus === UserStatusEnum.Offline) {
                let inputpar = new SetUserStatusDto();
                inputpar.userStatus = UserStatusEnum.Offline;
                inputpar.userId = abp.session.userId;
                inputpar.tenantId = abp.session.tenantId;
                this._signalRService.sendMessage('SignalRChangeStatusOnAgentAppForCheckinCheckout',inputpar);
            }
            if (this.passStatus === UserStatusEnum.Online) {
                let inputpar = new SetUserStatusDto();
                inputpar.userStatus = UserStatusEnum.Online;
                inputpar.userId = abp.session.userId;
                inputpar.tenantId = abp.session.tenantId;
                this._signalRService.sendMessage('SignalRChangeStatusOnAgentAppForCheckinCheckout',inputpar);
            }
                  
        });
    }

    changestate() {
       
        this.passStatus = this.userCurrentStatus === 'CheckIn' ? UserStatusEnum.Online : UserStatusEnum.Offline;
        if (this.passStatus == UserStatusEnum.Offline) {
            this.timerSub.unsubscribe();
        }

       else if (this.userCurrentStatus === 'CheckIn') {
            this.UserstateChechInCheckOuttimer(this.CheckinOffset);
        }        
        this.userCurrentStatus = this.userCurrentStatus === 'CheckIn' ? 'CheckOut' : 'CheckIn';
        let checkInCheckOutDto = new CheckInCheckOutDto()
        checkInCheckOutDto.userId = 0;
        checkInCheckOutDto.status = this.passStatus;
        this._AllDashboardServiceProxy.checkInCheckOut(checkInCheckOutDto).subscribe(() => {
            this.userCheckInCheckOut();
        });
        let d = new Date();
        this._AllDashboardServiceProxy.getCurrentStateCheckInCheckOut(abp.session.userId, abp.session.tenantId,d.getTimezoneOffset(),DateTime.fromJSDate(this.setZeroTimeForLocalDate(d))).subscribe(r => {
        })
    }


    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
       
        if (!date) return;
        let jsDate = new Date(
            `${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day
            }T${date.hour < 10 ? '0' + date.hour : date.hour}:${date.minute < 10 ? '0' + date.minute : date.minute}:00`
        );
       // alert(new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000));
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);

    }

    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    userFullname(name: string) {
        if(!name)return '-';
        let fullname = name.split(" ");
        name = fullname.length > 1 && fullname[1] != '' ?this.getTitleCase(fullname[0])+" "+this.getTitleCase(fullname[1]) : this.getTitleCase(fullname[0]);
         return name ;
     }
 
     // function which return titlecase string;
     getTitleCase(s : string){
         let char = s[0].toUpperCase();
         return char + s.slice(1)?.toLowerCase();
    }
}
